export default {"src":"/_next/static/media/send.727b49ea.svg","height":16,"width":17};